//@flow

import * as React from 'react';
import styled from 'styled-components';
import shadeColor from './../utilities/shadeColor';

type Props = {
    left?: string,
    right?: string,
    top?: string,
    bottom?: string,
    type?: string,
    onClick: () => void,
};

const btnActiveColor = '#1d406b';
const btnDefaultColor = '#265a9c';
const btnWarningColor = '#cf4444';
const btnLiveColor = '#ff000';

const StyledButton = styled.div`
    left: ${props => props.left};
    right: ${props => props.right};
    top: ${props => props.top};
    bottom: ${props => props.bottom};    
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: #fff;
    user-select: none;
    vertical-align: middle;
    z-index: 0;
    transition: all 0.1s ease-in-out;
    padding: 2px;
    text-decoration: none;
    text-align: start;
    letter-spacing: .5px;
    border: none;
    border-radius: 2px;
    box-shadow:  ${props => props.active
            ? 'inset 0 1px 3px rgba(0,0,0,0.12), inset 0 1px 2px rgba(0,0,0,0.24);'
            : '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);'
        };
    animation-name: ${props => !props.active && props.type === 'live' ? 'glow' : ''};
    animation-duration: 3s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    @keyframes glow{
        0% {background-color: #990000; box-shadow: inset 0 1px 3px rgba(0,0,0,0.12), inset 0 1px 2px rgba(0,0,0,0.24);}
        50% {background-color: #e60000; box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);}
        100% {background-color: #990000; box-shadow: inset 0 1px 3px rgba(0,0,0,0.12), inset 0 1px 2px rgba(0,0,0,0.24);}
    }

  >div>div{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* disabled */
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};   
  cursor: ${props => props.disabled ? 'default' : 'pointer'};   
  background-color: ${props => props.disabled
        ? shadeColor(props.backgroundColor, 0.5)
        : props.active
            ? btnActiveColor
            : props.backgroundColor
    };   

  :hover{
    background-color: ${props => props.active
        ? shadeColor(btnActiveColor, 0.2)
        : shadeColor(props.backgroundColor, 0.2)};    
    box-shadow:  ${props => props.active
        ? 'inset 0 2px 4px rgba(0,0,0,0.16), inset 0 2px 4px rgba(0,0,0,0.23);'
        : '0 2px 4px rgba(0,0,0,0.16), 0 2px 4px rgba(0,0,0,0.23);'
    };
  }

  /* not visible */
  display: ${props => props.visible === false ? 'none' : 'flex'};
`;

/*
    height: 10px;
    width: 10px;
    background: red;
    border-radius: 5px;

*/

const DefaultButton = (props: Props): React.Node => {
    let backgroundColor;
    switch (props.type) {
        case 'live':
            backgroundColor = btnLiveColor;
            break;
        case 'warning':
            backgroundColor = btnWarningColor;
            break;
        default:
            backgroundColor = btnDefaultColor;
            break;
    }
    const expandedProps = { backgroundColor, ...props };
    return (
        <StyledButton
            tabIndex='0'
            onKeyDown={(event) => {
                if (event.key === 'Enter') {
                    props.onClick();
                }
            }}
            {
            ...expandedProps
            } />
    )
};

export default DefaultButton;


// WEBPACK FOOTER //
// ./src/components/DefaultButton.jsx